import styled from 'styled-components';

export const TotalValuesWrapper = styled.div`
  padding: 20px 0;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: end;

  width: 90%;
  min-width: 0;
  max-width: 888px;

  @media (max-width: 700px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;

export const Row = styled.tr``;

export const Td = styled.td`
  &:nth-child(5n),
  &:nth-child(6n),
  &:nth-child(7n),
  &:nth-child(8n),
  &:nth-child(9n) {
    font-weight: 600;
  }

  &:nth-child(9n) {
    color: ${({ theme }) => theme.colors.primary[30]};
  }
`;

export const ContentHeader = styled.header`
  border-bottom: 1px solid #ebebeb;
  padding: 0 0 20px;

  h2 {
    color: ${({ theme }) => theme.colors.primary[30]};
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;

    text-align: center;
  }
`;

export const ContentBody = styled.body`
  padding: 4px 12px;

  background: ${({ theme }) => theme.colors.white};

  width: fit-content;
`;

export const ContentFooter = styled.footer`
  display: flex;
  gap: 20px;
  justify-content: end;

  padding: 24px 0 0 0;
`;

export const PainelValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: fit-content;

  h3 {
    background-color: ${({ theme }) => theme.colors.orange.primary};
    color: white;
    font-size: clamp(16px, 2.5vw, 18px);
    font-weight: 600;
    line-height: 150%;
    align-self: start;
    padding: 4px 8px;
    width: 100%;
    border-radius: 8px;
  }
`;

export const ByEstablishmentValuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: fit-content;

  padding-top: 16px;
  border-top: 1px solid #ebebeb;

  h3 {
    background-color: ${({ theme }) => theme.colors.gray[200]};
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`;

interface StatusLabelProps {
  labelBefore: string;
}

export const StatusLabel = styled.div<StatusLabelProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  cursor: default;

  &:hover:before {
    display: none;
    /*Triangulo*/
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    /*Faz seta "apontar para baixo. Definir o valor como 'top' fará ela "apontar para cima" */
    /*Aqui entra a cor da "aba" do balão */
    border-top: 10px solid #fff;
    top: -8px;
    left: 0px;
  }

  &:hover:after {
    display: none;
    content: ${({ labelBefore }) => `'${labelBefore}'`};
    position: absolute;
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 12px;
    text-transform: initial;

    height: fit-content;
    width: fit-content;
    white-space: nowrap;

    padding: 0px 24px;

    border-radius: 8px;

    top: -26px;
    left: -52px;

    box-shadow: 0px 4px 16px ${({ theme }) => theme.colors.gray[400]};
    background-color: ${({ theme }) => theme.colors.background.white};
  }

  &[role='Falha na Solicitação']:hover::before {
    display: block;
  }

  &[role='Falha na Solicitação']:hover::after {
    display: block;
  }

  &[role='Aguardando Solicitação'] {
    background-color: ${({ theme }) => theme.colors.gray[200]};
  }

  &[role='Falha na Solicitação'] {
    background-color: ${({ theme }) => theme.colors.attention};
    color: white;
  }
  &[role='Antecipação Solicitada'] {
    background-color: ${({ theme }) => theme.colors.succesful};
    color: white;
  }

  &[role='Processando'] {
    background-color: ${({ theme }) => theme.colors.yellow.primary};
  }

  border-radius: 8px;

  font-size: clamp(12px, 2.5vw, 14px);
  font-weight: 600;

  border: none;

  position: relative;
`;
